export default "__VITE_ASSET__Dh8ZFcuK__"